module.exports = __webpack_public_path__ + "static/media/sha3.0723b71e.webp";